export default {
  identity: {
    index: 36,
    noDivider: true,
    heading: 'heading.prefinalPage',
    previous: 'myDoctor/myDoctor'
  }
};
